/**
 * Google Analytics 4 Configuration
 *
 * El Measurement ID es público (va en el HTML de cualquier sitio con GA),
 * por eso hay un valor por defecto: si falta VUE_APP_GOOGLE_ANALYTICS_ID
 * en Netlify, GA sigue funcionando en lugar de apagarse en silencio.
 *
 * Nota: Las variables de entorno deben empezar con VUE_APP_ para ser accesibles en Vue
 */

const debug = process.env.NODE_ENV === 'development';

export default {
  measurementId: process.env.VUE_APP_GOOGLE_ANALYTICS_ID || 'G-GC0FYJ4YNJ',

  config: {
    // Los page_view los envía el plugin en cada cambio de ruta (con título y
    // content_group). Dejarlo en true duplicaría la primera página vista.
    send_page_view: false,
    // Hace visibles los eventos en GA > Admin > DebugView
    ...(debug && { debug_mode: true }),
  },

  // Habilitar solo en producción (o en dev con VUE_APP_ENABLE_ANALYTICS=true)
  enabled: process.env.NODE_ENV === 'production' || process.env.VUE_APP_ENABLE_ANALYTICS === 'true',

  debug,
};
